import { Deserializable } from '../deserializable';
import {ToaNha} from './toanha';
import {LoaiPhong} from './loaiphong';


export  class Phong implements Deserializable{
  public id: number;
  public tenPhong: string;
  public toaNhaID: number;
  public loaiPhongID: number;
  public sucChua: number;
  public thietBi: string;
  public stt: number;
  public toaNha: ToaNha;
  public loaiPhong: LoaiPhong;
  deserialize(input: any): this {
    Object.assign(this, input);
    this.toaNha = new ToaNha().deserialize(input.toaNha);
    this.loaiPhong = new LoaiPhong().deserialize(input.loaiPhong);
    return this;
  }
}
